import React from 'react';
import { TooltipProps, Tooltip, styled } from '@mui/material';
import { useIsTooltipOpen } from '../../Context/Layout.context';
import { fillTooltipArrow } from '../../utils/contrastSvgAttributes';

const StyledTooltip = styled<typeof Tooltip>(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))``;

const TooltipOne: React.FC<TooltipProps> = (props) => {
  const isTooltipOpen = useIsTooltipOpen();
  return (
    <StyledTooltip
      sx={{
        '& .MuiTooltip-arrow': {
          '&:before': {
            border: 'solid 1px',
            borderColor: '#FFFFFF',
          },
          color: fillTooltipArrow,
        },
        '& .MuiTooltip-tooltip': {
          background: '#2C2D3E',
          border: '1px solid white',
          fontSize: '1em',
        },
      }}
      arrow
      disableInteractive={false}
      onOpen={() => (isTooltipOpen.current = true)}
      onClose={() => (isTooltipOpen.current = false)}
      {...props}
    >
      {props.children}
    </StyledTooltip>
  );
};

export default React.memo(TooltipOne);
